import { useState, useEffect } from 'react';
import { ClientService } from '../../../../services/clientService';
import { CandidateService } from '../../../../services/candidateService';
import _ from 'lodash';
import {
  ShortlistingPopup,
  NewFolderPopup,
  FolderSelectionPopup,
  ShortlistSuccessPopup,
  RejectionPopup,
} from './index';
import { ClientFolderService } from '../../../../services/clientFolderService';

export const getFullName = (candidate) => {
  if (!candidate || !candidate.personalDetails) return '';
  const firstName = _.get(candidate.personalDetails, 'firstName', '');
  const lastName = _.get(candidate.personalDetails, 'lastName', '');
  return `${firstName} ${lastName}`.trim();
};

export const PopupContainer = ({
  activePopup,
  newFolderName,
  setActivePopup,
  shortlistedCandidates,
  setShortlistedCandidates,
  handleProfileSaving,
  openNewFolderPopup,
  setNewFolderName,
  showShortlistingPopup,
  clientId,
  candidateId,
  selectedCandidateId,
  selectedClientId,
  selectedFolder,
  setSelectedFolder,
  confirmRejection,
  isRejectionPopupVisible,
  setRejectionPopupVisible
}) => {
  const [folders, setFolders] = useState([]);
  const [candidateData, setCandidateData] = useState(null);
  const [shortlistNote, setShortlistNote] = useState('');

  const PAGE_SIZE = 10;

  const [folderPage, setFolderPage] = useState(0);
  const [folderTotalPages, setFolderTotalPages] = useState(1);

  // useEffect(() => {
  //   const fetchFolders = async () => {
  //     const response = await ClientFolderService.listShortlistedFolders(clientId);
  //     setFolders(response.data);
  //   };
  //   fetchFolders();
  // }, [clientId]);

  useEffect(() => {
    const fetchFolders = async () => {
      try {
        const response =
          await ClientFolderService.listShortlistedFolders(
            clientId,
            "SHORTLISTED",
            folderPage,
            PAGE_SIZE
          );

        setFolders(response.data.folders || []);

        const totalCount = response?.data?.totalCount || 0;

        setFolderTotalPages(
          Math.ceil(totalCount / PAGE_SIZE)
        );

      } catch (error) {
        console.error("Error fetching folders:", error);
        setFolders([]);
      }
    };

    fetchFolders();
  }, [clientId, folderPage]);

  useEffect(() => {
    const fetchCandidate = async () => {
      if (selectedCandidateId) {
        const response = await CandidateService.getCandidateById(selectedCandidateId);
        setCandidateData(response.data.candidates[0].candidate);
      }
    };
    fetchCandidate();
  }, [selectedCandidateId]);

  const fullName = getFullName(candidateData);
  const handleCreateFolder = (updatedFolders) => {
    setFolders(updatedFolders);
    setActivePopup('folderSelection');
  };
  useEffect(() => {
    if (!activePopup) {
      setSelectedFolder(null);
      setShortlistNote('');
    }
  }, [activePopup]);

  const handleSelectFolder = (folder) => {
    setSelectedFolder(folder);
    setActivePopup('folderSelection');
  };



  const openShortlistingPopup = () => setActivePopup('shortlisting');

  return (
    <>
      <ShortlistingPopup
        isPopupVisible={activePopup === 'shortlisting'}
        closePopup={() => setActivePopup(null)}
        openNewFolderPopup={openNewFolderPopup}
        shortlistedCandidates={shortlistedCandidates}
        newFolderName={newFolderName}
        getFullName={fullName}
        folders={folders}
        onSelectFolder={handleSelectFolder}
        note={shortlistNote}
        setNote={setShortlistNote}

        folderPage={folderPage}
        setFolderPage={setFolderPage}
        folderTotalPages={folderTotalPages}
      />

      <NewFolderPopup
        isNewFolderPopupVisible={activePopup === 'newFolder'}
        closeNewFolderPopup={() => setActivePopup(null)}
        handleCreateFolder={handleCreateFolder}
        newFolderName={newFolderName}
        setNewFolderName={setNewFolderName}
        clientId={clientId}
        setSelectedFolder={setSelectedFolder}
        shortlistNote={shortlistNote}
      />

      <FolderSelectionPopup
        isFolderSelectionPopupVisible={activePopup === 'folderSelection'}
        closePopup={() => setActivePopup(null)}
        handleProfileSaving={handleProfileSaving}
        getFullName={fullName}
        newFolderName={newFolderName}
        shortlistedCandidates={shortlistedCandidates}
        selectedCandidateId={selectedCandidateId}
        selectedClientId={selectedClientId}
        selectedFolder={selectedFolder}
        shortlistNote={shortlistNote}
        setShortlistNote={setShortlistNote}
        setShortlistedCandidates={setShortlistedCandidates}
        closeback={openShortlistingPopup}
      />

      <ShortlistSuccessPopup
        popupVisible={activePopup === 'shortlistSuccess'}
        closePopup={() => setActivePopup(null)}
        candidateId={selectedCandidateId}
        clientId={clientId}
        showShortlistingPopup={showShortlistingPopup}
      />

      <RejectionPopup
        isRejectionPopupVisible={isRejectionPopupVisible}
        closePopup={() => setRejectionPopupVisible(false)}
        candidateId={candidateId}
        clientId={clientId}
        confirmRejection={confirmRejection}
      />
    </>
  );
};